import { LoanStatus } from '@nemuru-eng/js-api-client';

import { Milestone } from '@/components/modules/Funnel/types/Milestone';
import { Step } from '@/components/modules/Funnel/types/Step';

export const StepsDefinitionsLoan = [
  {
    statuses: [LoanStatus.STATUS_INITIAL],
    tId: 'UNOPENED',
    associatedMilestone: Milestone.INITIAL,
  },
  {
    statuses: [LoanStatus.STATUS_OPENED],
    tId: 'OPENED',
  },
  {
    statuses: [LoanStatus.STATUS_KYC_SET],
    tId: 'PERSONAL_INFORMATION',
  },
  {
    statuses: [LoanStatus.STATUS_INCOME_SET],
    tId: 'FINANCIAL_INFORMATION',
  },
  {
    statuses: [LoanStatus.STATUS_PROFESSIONAL_DETAILS_SET],
    tId: 'PROFESSIONAL_INFORMATION',
  },
  {
    statuses: [LoanStatus.STATUS_RISK_SET],
    tId: 'RISK_INFORMATION',
  },
  {
    statuses: [LoanStatus.STATUS_ANALYSING],
    tId: 'REQUESTED',
    associatedMilestone: Milestone.REQUESTED,
  },
  {
    statuses: [LoanStatus.STATUS_LENDER_HAS_BEEN_SELECTED],
    tId: 'CONTRACT_NOT_SENT',
    associatedMilestone: Milestone.APPROVED,
  },
  {
    statuses: [LoanStatus.STATUS_CONTRACT_SENT],
    tId: 'CONTRACT_SENT',
  },
  {
    statuses: [LoanStatus.STATUS_CONTRACT_SIGNED],
    tId: 'VALIDATING_DOCUMENTATION',
  },
  {
    statuses: [LoanStatus.STATUS_DOCS_APPROVED],
    tId: 'CONFIRMED',
    associatedMilestone: Milestone.CONFIRMED,
  },
] as Step[];
